// js
import React from 'react';
import PropTypes from 'prop-types';
import TitledCheckedList from '../common/TitledCheckedList';


const SecurityDashboardsDetailList = ({subcategory}) => {

  return (
    <TitledCheckedList
      title={subcategory.title}
      items={
        subcategory.dashboards.map(dashboard => (
          {
            label: dashboard.title,
            checked: dashboard.indexLevel === 'acceptable',
            warning: dashboard.indexLevel === 'rudimentary'
          }
        ))
      }
    />
  );
};

SecurityDashboardsDetailList.propTypes = {
  subcategory: PropTypes.object.isRequired
};

export default SecurityDashboardsDetailList;



// WEBPACK FOOTER //
// ./src/components/analytics/SecurityDashboardsDetailList.js